export default __webpack_public_path__ + "static/blob10-3ecca19a295d91370ba2ac9d601eb6fb.svg";